(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-provider-games/assets/javascripts/page-provider-games.js') >= 0) return;  svs.modules.push('/components/casino-react/page-provider-games/assets/javascripts/page-provider-games.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams;
const _React = React,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect;
const GridDisplayModes = svs.components.casino_react.common.constants.GridDisplayModes;
const CasinoSection = svs.components.casino_react.casinoSection.CasinoSection;
const FilterAndSort = svs.components.casino_react.filterAndSort.FilterAndSort;
const cmsProviderList = svs.casino_react.shared.data.cmsProviderList;
const useSetSearchParams = svs.components.casino_react.hooks.useSetSearchParams;
const useSearchResults = svs.components.casino_react.casinoStore.hooks.useSearchResults;
const SubHeader = svs.components.casino_react.sub_header.SubHeader;
const setMetaTags = svs.components.lbUtils.setMetaTags.setMetaTags;
const actionButtons = () => React.createElement(FilterAndSort, {
  includeProviderFilters: false
});
const PageProviderGames = () => {
  const _useParams = useParams(),
    providerName = _useParams.providerName;
  const _useSetSearchParams = useSetSearchParams(),
    setFilter = _useSetSearchParams.setFilter;
  const provider = useMemo(() => cmsProviderList.find(provider => provider.model.systemName === providerName), [providerName]);
  const shouldSkipFetch = !provider;
  useEffect(() => {
    var _provider$model;
    if (provider !== null && provider !== void 0 && (_provider$model = provider.model) !== null && _provider$model !== void 0 && _provider$model.provider) {
      setFilter({
        checked: true,
        type: 'providers',
        name: provider.model.provider
      });
    }
  }, [provider]);
  const _useSearchResults = useSearchResults({
      shouldSkipFetch
    }),
    games = _useSearchResults.games,
    error = _useSearchResults.error,
    isLoading = _useSearchResults.isLoading,
    isFetching = _useSearchResults.isFetching,
    totalGamesCount = _useSearchResults.totalGamesCount,
    fetchMore = _useSearchResults.fetchMore;
  useEffect(() => {
    if (provider !== null && provider !== void 0 && provider.model.provider) {
      setMetaTags({
        docTitle: "Spel fr\xE5n ".concat(provider.model.provider, " | ").concat(svs.casino_react.shared.data.seo.productName, " | Svenska Spel")
      });
    }
  }, [provider === null || provider === void 0 ? void 0 : provider.model.provider]);
  if (!provider) {
    return React.createElement("p", {
      className: "align-center margin-top-4 provider-not-found"
    }, "Vi hittade inga resultat f\xF6r leverant\xF6r:", ' ', React.createElement("span", {
      className: "f-italic bold"
    }, providerName));
  }
  return React.createElement(React.Fragment, null, React.createElement(SubHeader, {
    title: "Spel fr\xE5n ".concat(provider.model.provider)
  }), React.createElement("div", {
    className: "page-provider-games"
  }, React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    fetchMore: fetchMore,
    isSearchResult: Boolean(!isFetching && !isLoading && !error && games),
    items: !isLoading && !error && games ? games : [],
    title: totalGamesCount ? "".concat(totalGamesCount, " spel") : '',
    totalGamesCount: totalGamesCount
  })));
};
setGlobal('svs.components.casino_react.pageProviderGames.PageProviderGames', PageProviderGames);

 })(window);